import {
    usePortalMode,
    ContentButton,
    PortalDrawer,
    getJobNameDisplay,
    formatAddress,
} from '@servicetitan/cp-ui';
import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { Headline, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { getDateText } from '../../../../../../../utils/date-helper';
import { JobListItemStatus } from '../../../../../api/portal-dashboard.api';
import { SettingsStore } from '../../../../../api/settings.store';
import { JobsUrlMap } from '../../jobs-url-map';
import { AppointmentDrawerStore } from '../stores/appointment-drawer.store';
import { JobAppointmentsList } from './appointment-list';

export const AppointmentDrawer = observer(() => {
    const [drawerStore] = useDependencies(AppointmentDrawerStore);
    const job = drawerStore.job;
    const jobHref = `${JobsUrlMap.list}/${job?.number}`;
    const mode = usePortalMode();

    const [dateTimeUtils] = useDependencies(DateTimeUtils);
    const [settingsStore] = useDependencies(SettingsStore);

    const jobNameDisplay =
        getJobNameDisplay(
            job?.type,
            job?.serviceLocation?.address
                ? formatAddress(job?.serviceLocation?.address)
                : undefined,
            job?.serviceLocation?.name,
            job?.status === JobListItemStatus.Completed
                ? getDateText(dateTimeUtils, job?.lastAppointmentStartDate)
                : getDateText(dateTimeUtils, job?.firstNotCompletedAppointmentStartDate),
            settingsStore.jobNameDisplayOptions
        ) ?? '';

    const drawerHeader = (
        <Stack className="w-100" direction="row" justifyContent="space-between">
            <Headline>{job ? 'Job #' + job.number + ': ' + jobNameDisplay : 'Loading...'}</Headline>
            <ContentButton small outline href={jobHref}>
                {mode.mobile ? 'View' : 'View Job'}
            </ContentButton>
        </Stack>
    );

    return (
        drawerStore.isOpen && (
            <PortalDrawer
                mobile={mode.mobile}
                open={drawerStore.isOpen}
                title={job ? 'Job #' + job.number + ': ' + jobNameDisplay : 'Loading...'}
                drawer={{ header: drawerHeader }}
                onClose={drawerStore.close}
            >
                <JobAppointmentsList
                    jobId={job?.id ?? 0}
                    appointmentCount={job?.appointmentCount ?? 0}
                    isDrawer
                />
            </PortalDrawer>
        )
    );
});
